<!-- Start course-detail-state div -->
<div class="course-detail-state" *ngIf="loading" role="status">
  <!-- Start fa i -->
  <i class="fa fa-spinner fa-spin" aria-hidden="true">
  </i>
  <!-- End fa i -->
  Loading course details...
</div>
<!-- End course-detail-state div -->
<!-- Start course-detail-state div -->
<div class="course-detail-state" *ngIf="!loading && !course" role="alert">
  <!-- Start h1 -->
  <h1>Course details unavailable</h1>
  <!-- End h1 -->
  <!-- Start p -->
  <p>{{ message }}</p>
  <!-- End p -->
  <!-- Start cd-btn button -->
  <button type="button" class="cd-btn cd-btn-primary" (click)="loadPageData()">Try again</button>
  <!-- End cd-btn button -->
  <!-- Start cd-btn a -->
  <a class="cd-btn cd-btn-outline" routerLink="/course-qualifications" [queryParams]="backToCoursesQueryParams">Back to
    long courses</a>
  <!-- End cd-btn a -->
</div>
<!-- End course-detail-state div -->
<!-- Start course-detail main -->
<main class="course-detail" *ngIf="course">
  <!-- Start cd-shell div -->
  <div class="cd-shell">
    <!-- Start cd-page-navigation div -->
    <div class="cd-page-navigation">
      <!-- Start cd-back-btn a -->
      <a class="cd-back-btn" routerLink="/course-qualifications" [queryParams]="backToCoursesQueryParams"
        aria-label="Back to all long courses">
        <!-- Start fa i -->
        <i class="fa fa-arrow-left" aria-hidden="true">
        </i>
        <!-- End fa i -->
        <!-- Start span -->
        <span>Back to Courses</span>
        <!-- End span -->
      </a>
      <!-- End cd-back-btn a -->
      <!-- Start cd-breadcrumb nav -->
      <nav class="cd-breadcrumb" aria-label="Breadcrumb">
        <!-- Start a -->
        <a routerLink="/">Home</a>
        <!-- End a -->
        <!-- Start fa i -->
        <i class="fa fa-angle-right" aria-hidden="true">
        </i>
        <!-- End fa i -->
        <!-- Start a -->
        <a routerLink="/course-qualifications" [queryParams]="backToCoursesQueryParams">Long courses</a>
        <!-- End a -->
        <!-- Start fa i -->
        <i class="fa fa-angle-right" aria-hidden="true">
        </i>
        <!-- End fa i -->
        <!-- Start span -->
        <span>{{ course.courseCode || displayCourseTitle }}</span>
        <!-- End span -->
      </nav>
      <!-- End cd-breadcrumb nav -->
    </div>
    <!-- End cd-page-navigation div -->
    <!-- Start cd-hero section -->
    <section class="cd-hero" aria-labelledby="course-title">
      <!-- Start cd-hero-background div -->
      <div class="cd-hero-background" [class.cd-default-hero]="!hasConfiguredCourseImage" aria-hidden="true">
        <!-- Start img -->
        <img [src]="heroImageUrl" alt="" (error)="imageFallback($event)">
        <!-- End img -->
        <!-- Start ng-container -->
        <ng-container *ngIf="hasConfiguredCourseImage">
          <!-- Start cd-hero-swoosh div -->
          <div class="cd-hero-swoosh">
          </div>
          <!-- End cd-hero-swoosh div -->
          <!-- Start cd-values div -->
          <div class="cd-values">
            <!-- Start span -->
            <span>
              <!-- Start fa i -->
              <i class="fa fa-heart-o">
              </i>
              <!-- End fa i -->
              Support
            </span>
            <!-- End span -->
            <!-- Start span -->
            <span>
              <!-- Start fa i -->
              <i class="fa fa-users">
              </i>
              <!-- End fa i -->
              Empower
            </span>
            <!-- End span -->
            <!-- Start span -->
            <span>
              <!-- Start fa i -->
              <i class="fa fa-shield">
              </i>
              <!-- End fa i -->
              Respect
            </span>
            <!-- End span -->
            <!-- Start span -->
            <span>
              <!-- Start fa i -->
              <i class="fa fa-leaf">
              </i>
              <!-- End fa i -->
              Make a Difference
            </span>
            <!-- End span -->
          </div>
          <!-- End cd-values div -->
        </ng-container>
        <!-- End ng-container -->
      </div>
      <!-- End cd-hero-background div -->
      <!-- Start cd-hero-shade div -->
      <div class="cd-hero-shade" aria-hidden="true">
      </div>
      <!-- End cd-hero-shade div -->
      <!-- Start cd-hero-copy div -->
      <div class="cd-hero-copy">
        <!-- Start cd-course-code div -->
        <div class="cd-course-code" *ngIf="course.courseCode">{{ course.courseCode }}</div>
        <!-- End cd-course-code div -->
        <!-- Start cd-course-title h1 -->
        <h1 id="course-title" class="cd-course-title">
          <!-- Start span -->
          <span>{{ displayCourseTitleMain }}</span>
          <!-- End span -->
          <!-- Start cd-course-title-accent span -->
          <span class="cd-course-title-accent" *ngIf="displayCourseTitleAccent">{{ displayCourseTitleAccent }}</span>
          <!-- End cd-course-title-accent span -->
        </h1>
        <!-- End cd-course-title h1 -->
        <!-- Start h2 -->
        <!-- <div *ngIf="course.shortDescription" class="course-short-description-rte" [innerHTML]="course.shortDescription"></div> -->
        <div class="course-short-description-rte"> </div>
        <!-- End h2 -->
        <!-- Start cd-hero-description div -->
        <div class="cd-hero-description course-rte-view" *ngIf="course.shortDescription" style="margin-top: 15px;"
          [innerHTML]="course.shortDescription | safeHtml">
        </div>
        <!-- End cd-hero-description div -->
        <!-- Start cd-actions div -->
        <div class="cd-actions">
          <!-- Start cd-btn a -->
          <a class="cd-btn cd-btn-enquire" routerLink="/contact-us" [queryParams]="enquiryParams"
            fragment="course-enquiry">
            Enquire Now
            <!-- Start fa i -->
            <i class="fa fa-arrow-right" aria-hidden="true">
            </i>
            <!-- End fa i -->
          </a>
          <!-- End cd-btn a -->
          <!-- Start cd-btn button -->
          <button *ngIf="course?.brochureUrl?.trim()" type="button" class="cd-btn cd-btn-outline"
            (click)="downloadBrochure()" [disabled]="downloadingBrochure" [attr.aria-busy]="downloadingBrochure"
            aria-label="Download course brochure">
            <!-- Start fa i -->
            <i class="fa" [ngClass]="downloadingBrochure ? 'fa-spinner fa-spin' : 'fa-download'" aria-hidden="true">
            </i>
            <!-- End fa i -->
            {{ downloadingBrochure ? 'Downloading...' : 'Download Brochure' }}
          </button>
          <!-- End cd-btn button -->
          <!-- Start cd-btn button -->
          <button type="button" class="cd-btn cd-btn-fees cd-btn-cart" (click)="addToCartAndViewCart()">
            <!-- Start fa i -->
            <i class="fa fa-shopping-cart" aria-hidden="true">
            </i>
            <!-- End fa i -->
            {{ isInCart() ? 'Change date' : 'Add to Cart' }} - {{ (course.isCluster && course.individualPrice ?
            course.individualPrice : course.price) | currency:currency:'symbol':'1.2-2' }}
            <!-- Start fa i -->
            <i class="fa fa-arrow-right" aria-hidden="true">
            </i>
            <!-- End fa i -->
          </button>
          <!-- End cd-btn button -->
        </div>
        <!-- End cd-actions div -->
      </div>
      <!-- End cd-hero-copy div -->
    </section>
    <!-- End cd-hero section -->
    <!-- Start cd-facts section -->
    <section class="cd-facts" aria-label="Course information">
      <!-- Start cd-fact-card article -->
      <article class="cd-fact-card">
        <!-- Start cd-round-icon span -->
        <span class="cd-round-icon">
          <!-- Start fa i -->
          <i class="fa fa-graduation-cap" aria-hidden="true">
          </i>
          <!-- End fa i -->
        </span>
        <!-- End cd-round-icon span -->
        <!-- Start div -->
        <div>
          <!-- Start h2 -->
          <h2>Delivery Mode</h2>
          <!-- End h2 -->
          <!-- Start ul -->
          <ul *ngIf="deliveryModes.length; else deliveryFallback">
            <!-- Start li -->
            <li *ngFor="let mode of deliveryModes">
              <!-- Start fa i -->
              <i class="fa fa-check-circle" aria-hidden="true">
              </i>
              <!-- End fa i -->
              {{ mode }}
            </li>
            <!-- End li -->
          </ul>
          <!-- End ul -->
          <!-- Start deliveryFallback ng-template -->
          <ng-template #deliveryFallback>
            <!-- Start p -->
            <p>{{ course.deliveryMode || 'Contact us for delivery options' }}</p>
            <!-- End p -->
          </ng-template>
          <!-- End deliveryFallback ng-template -->
        </div>
        <!-- End div -->
      </article>
      <!-- End cd-fact-card article -->
      <!-- Start cd-fact-card article -->
      <article class="cd-fact-card">
        <!-- Start cd-round-icon span -->
        <span class="cd-round-icon">
          <!-- Start fa i -->
          <i class="fa fa-calendar" aria-hidden="true">
          </i>
          <!-- End fa i -->
        </span>
        <!-- End cd-round-icon span -->
        <!-- Start div -->
        <div>
          <!-- Start h2 -->
          <h2>Duration</h2>
          <!-- End h2 -->
          <!-- Start ng-container -->
          <ng-container *ngIf="course.durationOptions?.length; else durationFallback">
            <!-- Start p -->
            <p *ngFor="let item of course.durationOptions">
              <!-- Start span -->
              <span>{{ item.label }}:</span>
              <!-- End span -->
              <!-- Start strong -->
              <strong>{{ item.duration }}</strong>
              <!-- End strong -->
            </p>
            <!-- End p -->
          </ng-container>
          <!-- End ng-container -->
          <!-- Start durationFallback ng-template -->
          <ng-template #durationFallback>
            <!-- Start p -->
            <p>Contact us for course duration</p>
            <!-- End p -->
          </ng-template>
          <!-- End durationFallback ng-template -->
        </div>
        <!-- End div -->
      </article>
      <!-- End cd-fact-card article -->
      <!-- Start cd-fact-card article -->
      <article class="cd-fact-card cd-placement-card">
        <!-- Start cd-round-icon span -->
        <span class="cd-round-icon cd-green-icon">
          <!-- Start fa i -->
          <i class="fa fa-users" aria-hidden="true">
          </i>
          <!-- End fa i -->
        </span>
        <!-- End cd-round-icon span -->
        <!-- Start div -->
        <div>
          <!-- Start h2 -->
          <h2>Placement</h2>
          <!-- End h2 -->
          <!-- Start p -->
          <p *ngIf="course.placementHours">
            <!-- Start span -->
            <span>Minimum</span>
            <!-- End span -->
            <!-- Start br -->
            <br>
            <!-- End br -->
            <!-- Start cd-placement-hours strong -->
            <strong class="cd-placement-hours">{{ course.placementHours }} hours</strong>
            <!-- End cd-placement-hours strong -->
          </p>
          <!-- End p -->
          <!-- Start p -->
          <p *ngIf="!course.placementHours">Contact us for placement requirements</p>
          <!-- End p -->
        </div>
        <!-- End div -->
      </article>
      <!-- End cd-fact-card article -->
    </section>
    <!-- End cd-facts section -->
    <!-- Start cd-about-grid section -->
    <section class="cd-about-grid" [class.cd-about-full]="!prerequisites.length">
      <!-- Start cd-panel article -->
      <article class="cd-panel cd-about-panel">
        <!-- Start cd-panel-title header -->
        <header class="cd-panel-title">
          <!-- Start h2 -->
          <h2>About This Course</h2>
          <!-- End h2 -->
        </header>
        <!-- End cd-panel-title header -->
        <!-- Start course-rte-view div -->
        <div class="course-rte-view cd-about-text" [innerHTML]="aboutCourseHtml | safeHtml">
        </div>
        <!-- End course-rte-view div -->
        <!-- Start cd-panel-actions div -->
        <div class="cd-panel-actions">
          <!-- Start cd-btn a -->
          <a class="cd-btn cd-btn-enquire" routerLink="/contact-us" [queryParams]="enquiryParams"
            fragment="course-enquiry">
            Enquire Now
            <!-- Start fa i -->
            <i class="fa fa-arrow-right" aria-hidden="true">
            </i>
            <!-- End fa i -->
          </a>
          <!-- End cd-btn a -->
          <!-- Start cd-btn a -->
          <a *ngIf="brochureLink as brochure" class="cd-btn cd-btn-outline" [href]="brochure" download
            aria-label="Download course brochure">
            <!-- Start fa i -->
            <i class="fa fa-download" aria-hidden="true">
            </i>
            <!-- End fa i -->
            Download Brochure
          </a>
          <!-- End cd-btn a -->
          <!-- Start cd-btn button -->
          <button type="button" class="cd-btn cd-btn-fees cd-btn-cart" (click)="addToCartAndViewCart()">
            <!-- Start fa i -->
            <i class="fa fa-shopping-cart" aria-hidden="true">
            </i>
            <!-- End fa i -->
            {{ isInCart() ? 'Change date' : 'Add to Cart' }} - {{ (course.isCluster && course.individualPrice ?
            course.individualPrice : course.price) | currency:currency:'symbol':'1.2-2' }}
            <!-- Start fa i -->
            <i class="fa fa-arrow-right" aria-hidden="true">
            </i>
            <!-- End fa i -->
          </button>
          <!-- End cd-btn button -->
        </div>
        <!-- End cd-panel-actions div -->
      </article>
      <!-- End cd-panel article -->
      <!-- Start cd-panel article -->
      <article class="cd-panel cd-prereq-panel" *ngIf="prerequisites.length">
        <!-- Start cd-icon-title header -->
        <header class="cd-icon-title">
          <!-- Start cd-title-icon span -->
          <span class="cd-title-icon cd-title-icon-green">
            <!-- Start fa i -->
            <i class="fa fa-file-text-o" aria-hidden="true">
            </i>
            <!-- End fa i -->
          </span>
          <!-- End cd-title-icon span -->
          <!-- Start h2 -->
          <h2>Course Prerequisites</h2>
          <!-- End h2 -->
        </header>
        <!-- End cd-icon-title header -->
        <!-- Start p -->
        <p>To enrol in this course, you should have:</p>
        <!-- End p -->
        <!-- Start cd-check-list ul -->
        <ul class="cd-check-list">
          <!-- Start li -->
          <li *ngFor="let item of prerequisites">
            <!-- Start fa i -->
            <i class="fa fa-check" aria-hidden="true">
            </i>
            <!-- End fa i -->
            <!-- Start span -->
            <span>{{ item }}</span>
            <!-- End span -->
          </li>
          <!-- End li -->
        </ul>
        <!-- End cd-check-list ul -->
      </article>
      <!-- End cd-panel article -->
    </section>
    <!-- End cd-about-grid section -->
    <!-- Start cd-outcomes-grid section -->
    <section class="cd-outcomes-grid" id="course-outcomes" *ngIf="outcomes.length || pathways.length"
      [class.cd-about-full]="!pathways.length">
      <!-- Start cd-panel article -->
      <article class="cd-panel" *ngIf="outcomes.length">
        <!-- Start cd-icon-title header -->
        <header class="cd-icon-title">
          <!-- Start cd-title-icon span -->
          <span class="cd-title-icon">
            <!-- Start fa i -->
            <i class="fa fa-briefcase" aria-hidden="true">
            </i>
            <!-- End fa i -->
          </span>
          <!-- End cd-title-icon span -->
          <!-- Start h2 -->
          <h2>Career Opportunities</h2>
          <!-- End h2 -->
        </header>
        <!-- End cd-icon-title header -->
        <!-- Start p -->
        <p>This qualification can lead to a variety of rewarding roles, including:</p>
        <!-- End p -->
        <!-- Start cd-career-list ul -->
        <ul class="cd-career-list">
          <!-- Start li -->
          <li *ngFor="let outcome of outcomes">
            <!-- Start fa i -->
            <i class="fa fa-check" aria-hidden="true">
            </i>
            <!-- End fa i -->
            <!-- Start span -->
            <span>{{ outcome }}</span>
            <!-- End span -->
          </li>
          <!-- End li -->
        </ul>
        <!-- End cd-career-list ul -->
      </article>
      <!-- End cd-panel article -->
      <!-- Start cd-panel article -->
      <article class="cd-panel" *ngIf="pathways.length">
        <!-- Start cd-icon-title header -->
        <header class="cd-icon-title">
          <!-- Start cd-title-icon span -->
          <span class="cd-title-icon">
            <!-- Start fa i -->
            <i class="fa fa-bar-chart" aria-hidden="true">
            </i>
            <!-- End fa i -->
          </span>
          <!-- End cd-title-icon span -->
          <!-- Start h2 -->
          <h2>Pathways to Further Study</h2>
          <!-- End h2 -->
        </header>
        <!-- End cd-icon-title header -->
        <!-- Start p -->
        <p>{{ course.pathwaysIntroduction || 'Continue your learning journey and build your career with further study.'
          }}</p>
        <!-- End p -->
        <!-- Start cd-pathway-list div -->
        <div class="cd-pathway-list">
          <!-- Start a -->
          <a *ngFor="let pathway of pathways" [routerLink]="['/courses', pathway.relatedCourseId]">
            <!-- Start cd-pathway-text span -->
            <span class="cd-pathway-text">
              <!-- Start strong -->
              <strong *ngIf="pathway.courseCode">{{ pathway.courseCode }}</strong>
              <!-- End strong -->
              <!-- Start cd-pathway-separator span -->
              <span class="cd-pathway-separator" *ngIf="pathway.courseCode">-</span>
              <!-- End cd-pathway-separator span -->
              <!-- Start span -->
              <span>{{ pathway.courseName }}</span>
              <!-- End span -->
            </span>
            <!-- End cd-pathway-text span -->
            <!-- Start fa i -->
            <i class="fa fa-angle-right" aria-hidden="true">
            </i>
            <!-- End fa i -->
          </a>
          <!-- End a -->
        </div>
        <!-- End cd-pathway-list div -->
        <!-- Start cd-info-note div -->
        <div class="cd-info-note">
          <!-- Start fa i -->
          <i class="fa fa-info" aria-hidden="true">
          </i>
          <!-- End fa i -->
          <!-- Start span -->
          <span>
            {{ course.pathwaysNote ||
            'Graduates can continue their studies in a range of community services and health related qualifications.'
            }}
          </span>
          <!-- End span -->
        </div>
        <!-- End cd-info-note div -->
      </article>
      <!-- End cd-panel article -->
    </section>
    <!-- End cd-outcomes-grid section -->
    <!-- Start cd-panel section -->
    <section class="cd-panel cd-units-panel" id="course-units" *ngIf="coreUnits.length || electiveUnits.length">
      <!-- Start cd-icon-title header -->
      <header class="cd-icon-title">
        <!-- Start cd-title-icon span -->
        <span class="cd-title-icon">
          <!-- Start fa i -->
          <i class="fa fa-book" aria-hidden="true">
          </i>
          <!-- End fa i -->
        </span>
        <!-- End cd-title-icon span -->
        <!-- Start h2 -->
        <h2>Course Units</h2>
        <!-- End h2 -->
      </header>
      <!-- End cd-icon-title header -->
      <!-- Start p -->
      <p>{{ displayCourseTitle }} includes the following units:</p>
      <!-- End p -->
      <!-- Start cd-accordion div -->
      <div class="cd-accordion" *ngIf="coreUnits.length">
        <!-- Start cd-accordion-header button -->
        <button type="button" class="cd-accordion-header" (click)="coreUnitsOpen = !coreUnitsOpen"
          [attr.aria-expanded]="coreUnitsOpen">
          <!-- Start span -->
          <span>
            <!-- Start fa i -->
            <i class="fa fa-book" aria-hidden="true">
            </i>
            <!-- End fa i -->
            <!-- Start strong -->
            <strong>Core Units ({{ coreUnits.length }})</strong>
            <!-- End strong -->
          </span>
          <!-- End span -->
          <!-- Start fa i -->
          <i class="fa" [ngClass]="coreUnitsOpen ? 'fa-minus' : 'fa-plus'" aria-hidden="true">
          </i>
          <!-- End fa i -->
        </button>
        <!-- End cd-accordion-header button -->
        <!-- Start cd-accordion-body div -->
        <div class="cd-accordion-body" *ngIf="coreUnitsOpen">
          <!-- Start cd-unit-row div -->
          <div class="cd-unit-row" *ngFor="let unit of coreUnits">
            <!-- Start strong -->
            <strong>{{ unit.code || '—' }}</strong>
            <!-- End strong -->
            <!-- Start span -->
            <span>{{ unit.name }}</span>
            <!-- End span -->
          </div>
          <!-- End cd-unit-row div -->
        </div>
        <!-- End cd-accordion-body div -->
      </div>
      <!-- End cd-accordion div -->
      <!-- Start cd-accordion div -->
      <div class="cd-accordion" *ngIf="electiveUnits.length">
        <!-- Start cd-accordion-header button -->
        <button type="button" class="cd-accordion-header" (click)="electiveUnitsOpen = !electiveUnitsOpen"
          [attr.aria-expanded]="electiveUnitsOpen">
          <!-- Start span -->
          <span>
            <!-- Start fa i -->
            <i class="fa fa-book" aria-hidden="true">
            </i>
            <!-- End fa i -->
            <!-- Start strong -->
            <strong>Elective Units ({{ electiveUnits.length }})</strong>
            <!-- End strong -->
          </span>
          <!-- End span -->
          <!-- Start fa i -->
          <i class="fa" [ngClass]="electiveUnitsOpen ? 'fa-minus' : 'fa-plus'" aria-hidden="true">
          </i>
          <!-- End fa i -->
        </button>
        <!-- End cd-accordion-header button -->
        <!-- Start cd-accordion-body div -->
        <div class="cd-accordion-body" *ngIf="electiveUnitsOpen">
          <!-- Start cd-unit-row div -->
          <div class="cd-unit-row" *ngFor="let unit of electiveUnits">
            <!-- Start strong -->
            <strong>{{ unit.code || '—' }}</strong>
            <!-- End strong -->
            <!-- Start span -->
            <span>{{ unit.name }}</span>
            <!-- End span -->
          </div>
          <!-- End cd-unit-row div -->
        </div>
        <!-- End cd-accordion-body div -->
      </div>
      <!-- End cd-accordion div -->
    </section>
    <!-- End cd-panel section -->
    <!-- Start cd-panel section -->
    <!-- End cd-panel section -->
    <!-- Start cd-panel section -->
    <!-- End cd-panel section -->
    <!-- Start cd-training-recognition section -->
    <section class="cd-training-recognition" aria-label="Training recognition and funding information">
      <!-- Start cd-training-recognition-logo div -->
     <!--  <div class="cd-training-recognition-logo"> -->
        <!-- Start img -->
       <!--  <img src="assets/images/vicseg-nationally-recognised-training.png" alt="Nationally Recognised Training"> -->
        <!-- End img -->
     <!--  </div> -->
      <!-- End cd-training-recognition-logo div -->
      <!-- Start cd-training-recognition-copy div -->
      <div class="cd-training-recognition-copy">
        <!-- Start p -->
        <p>ECB Training Services.</p>
        <!-- End p -->
        <!-- Start p -->
        <p>Registered Training Organisation (RTO) 41369.
        </p>
        <!-- End p -->
        <!-- Start p -->
        <p>Victoria | Northern Territory.</p>
        <!-- End p -->
      </div>
      <!-- End cd-training-recognition-copy div -->
    </section>
    <!-- End cd-training-recognition section -->
  </div>
  <!-- End cd-shell div -->
</main>
<!-- End course-detail main -->
<app-occurrence-picker *ngIf="showingOccurrencePicker && course" kind="QUALIFICATION" [courseId]="course.courseId"
  (closed)="showingOccurrencePicker=false"></app-occurrence-picker>